import axios from 'axios'
import { AppCookies } from '@models/classes/cookies'

const UNSAFE_METHODS = ['post', 'put', 'patch', 'delete']
const CSRF_HEADER = 'x-csrftoken'

const cookies = new AppCookies()

const api = axios.create({
  baseURL: `https://${import.meta.env.VITE_APP_DOMAIN}`,
  timeout: 60000,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase()
  if (!method || !UNSAFE_METHODS.includes(method)) return config
  if (config.withCredentials === false) return config
  if (config.headers.get(CSRF_HEADER)) return config

  const token = cookies.getCookie('csrftoken')
  if (token) config.headers.set(CSRF_HEADER, token)
  return config
})

export default api
